/**
 * Manage product slider (utilizes Slick slider package)
 */

/* global jQuery */

const $             = jQuery;   // jQuery loaded via WordPress enqueue process
const overlayMenu   = require('./overlay-menu');

let $sliders = null;

function initProductSliders() {
    let options = {
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,

        // responsive sizes represent MAX width -- everything smaller than specified
        // size (but not size itself) will receive specified settings
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 375,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    };

    $sliders.each(function () {
        let $slider = $(this).find('.product-slider__container');
        
        // Attach arrows for current slider to the options obj
        // options.prevArrow = $slider.parent().find('.slider-3up__prev');
        // options.nextArrow = $slider.parent().find('.slider-3up__next');

        $slider.slick(options);

        // Also, wire our 'Where to Buy' links 
        function initWhereToBuyLinks() {
            $slider.find('.js-where-to-buy').click((event) => {
                event.preventDefault();
                overlayMenu.showSearchForm();
            });
        }
        initWhereToBuyLinks();

        // ...and be sure to re-init the links when we hit our responsive
        // break points.
        $slider.on('breakpoint', function (event, slick, breakpoint) {
            initWhereToBuyLinks();
        });
    });
}


exports.init = function ($els) {
    $sliders = $els;
    initProductSliders();
};